import { render, staticRenderFns } from "./newproduct-overview.vue?vue&type=template&id=670e6aba&scoped=true&"
import script from "./newproduct-overview.vue?vue&type=script&lang=js&"
export * from "./newproduct-overview.vue?vue&type=script&lang=js&"
import style0 from "./newproduct-overview.vue?vue&type=style&index=0&id=670e6aba&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e6aba",
  null
  
)

export default component.exports